import Color from "./color/color.vue";
import Content from "./content/content.vue";
import Language from "./language/language.vue";
import Timer from "./timer/Timer.vue";
import Topics from "./topics/Topics.vue";
export default {
  Color,
  Content,
  Language,
  Timer,
  Topics
};
